import React from 'react'
import { Card, Switch } from 'antd'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const StyledCard = styled(Card)`
	margin-bottom: 1.5rem;

	@media (max-width: 768px) {
		margin-bottom: 1rem;
	}
`

const SwitchContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`

const SigningOrder = ({ signingOrder, onSigningOrderChange }) => {
	return (
		<StyledCard title="Ordem de Assinaturas">
			<SwitchContainer>
				<Switch checked={signingOrder} onChange={onSigningOrderChange} />
				<span>Ativa a ordenação na assinatura de documentos</span>
			</SwitchContainer>
		</StyledCard>
	)
}

SigningOrder.propTypes = {
	signingOrder: PropTypes.bool,
	onSigningOrderChange: PropTypes.func.isRequired,
}

export default SigningOrder
